<div class="space-y-1 relative mb-6">
  <label class="block text-sm font-medium text-gray-700 dark:text-gray-300">{{ label }}</label>

  <button
    type="button"
    (click)="onToggle()"
    [disabled]="disabled"
    [class.bg-gray-100]="disabled"
    [class.dark:bg-gray-800]="disabled"
    class="w-full px-3 py-2 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 text-gray-900 dark:text-gray-100 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-left flex items-center justify-between disabled:opacity-50 disabled:cursor-not-allowed"
  >
    <span
      class="break-words flex-1"
      [class.text-gray-500]="buttonTextMuted"
      [class.dark:text-gray-400]="buttonTextMuted"
    >{{ buttonText }}</span>
    <span
      *ngIf="selectedId !== null && !hideClear"
      (click)="onClear(); $event.stopPropagation()"
      class="flex-shrink-0 text-gray-400 hover:text-red-500 dark:hover:text-red-400 transition-colors cursor-pointer p-0.5 ml-1"
      title="Limpar"
    >
      <lucide-icon name="x" class="w-4 h-4"></lucide-icon>
    </span>
    <lucide-icon name="chevron-down" class="w-4 h-4 flex-shrink-0 text-gray-500 ml-1"></lucide-icon>
  </button>

  <div
    *ngIf="isOpen"
    class="absolute z-50 w-full mt-1 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg shadow-lg overflow-hidden flex flex-col"
  >
    <!-- Input de busca -->
    <div class="px-4 py-2 border-b border-gray-200 dark:border-gray-600 sticky top-0 bg-white dark:bg-gray-700">
      <div class="relative">
        <lucide-icon *ngIf="!searchTerm" name="search" class="absolute left-2 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400"></lucide-icon>
        <input
          type="text"
          [ngModel]="searchTerm"
          (ngModelChange)="onSearchModelChange($event)"
          [placeholder]="searchPlaceholder"
          [class]="searchTerm ? 'w-full pl-3 pr-8 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 focus:ring-2 focus:ring-blue-500 focus:border-blue-500' : 'w-full pl-8 pr-8 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 focus:ring-2 focus:ring-blue-500 focus:border-blue-500'"
          (click)="$event.stopPropagation()"
        />
        <button
          *ngIf="searchTerm"
          (click)="onClearSearch(); $event.stopPropagation()"
          class="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
        >
          <lucide-icon name="x" class="w-4 h-4"></lucide-icon>
        </button>
      </div>
    </div>

    <!-- Lista de opções (com scroll) -->
    <div class="relative">
      <!-- Inline: Tailwind não suporta overflow-y-scroll combinado com max-height sem risco de conflito com a classe dropdown-scroll-list; mantido como CSS inline para garantir o comportamento do scroll -->
      <div class="overflow-y-scroll dropdown-scroll-list pb-1" style="max-height: 14rem;">
        <div
          *ngFor="let option of options"
          (click)="onSelect(option)"
          class="px-4 py-3 hover:bg-blue-50 dark:hover:bg-blue-900/30 cursor-pointer border-b border-gray-100 dark:border-gray-600 last:border-b-0 transition-all duration-150"
          [ngClass]="{ 'bg-blue-100 dark:bg-blue-900/40': selectedId === getOptionId(option) }"
        >
          <div class="flex items-center justify-between">
            <span
              class="text-sm break-words"
              [ngClass]="{
                'text-gray-900 dark:text-gray-100': selectedId !== getOptionId(option),
                'text-blue-600 dark:text-blue-400': selectedId === getOptionId(option),
                'font-semibold': selectedId === getOptionId(option)
              }"
            >{{ getOptionLabel(option) }}</span>
            <lucide-icon
              *ngIf="selectedId === getOptionId(option)"
              name="check"
              class="w-4 h-4 text-blue-600 dark:text-blue-400 flex-shrink-0 ml-2"
            ></lucide-icon>
          </div>
        </div>
        <!-- Mensagem quando não há resultados -->
        <div *ngIf="options.length === 0 && searchTerm" class="px-3 py-4 text-center text-sm text-gray-500 dark:text-gray-400">
          {{ noResultsText }}
        </div>
      </div>
    </div>
  </div>
</div>
